import { EpimsBaseEntityDto } from './epim-base.dto';

  export class PipelineAssetLink2Dto extends EpimsBaseEntityDto{
    AutoLandId: string;
    AutoSerialId: string;
    LandName: string;
    SubSubGroupName: string;
    CategoryName: string;
    SubscriberId: string;
    SubscriptionUserId: string;
    LandTitleId: string;
  }